<template>
  <div>
    <el-descriptions class="margin-top" :column="1" border title="推荐人信息">
      <el-descriptions-item>
        <template slot="label">
          <span class="require-flag">*</span>推荐人是否自己写RL
        </template>
        <el-radio-group v-model="referrer.is_institution_write">
          <el-radio :label="1">机构写RL</el-radio>
          <el-radio :label="2">推荐人自己写RL</el-radio>
        </el-radio-group>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions class="margin-top" :column="2" border>
      <el-descriptions-item>
        <template slot="label">
          <span class="require-flag">*</span>
          中文(姓)
        </template>
        <el-input
          placeholder="与有效证件上一致"
          v-model="referrer.surname"
          clearable
        >
        </el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <span class="require-flag">*</span>
          中文(名)
        </template>
        <el-input
          placeholder="与有效证件上一致"
          v-model="referrer.personal_name"
          clearable
        >
        </el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <span class="require-flag">*</span>
          拼音(姓)
        </template>
        <el-input
          placeholder="请输入推荐人姓(英)"
          v-model="referrer.surname_en"
          clearable
        >
        </el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <span class="require-flag">*</span>
          拼音(名)
        </template>
        <el-input
          placeholder="请输入推荐人名(英)"
          v-model="referrer.personal_name_en"
          clearable
        >
        </el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <span class="require-flag">*</span>
          推荐人性别
        </template>
        <el-select v-model="referrer.sex" placeholder="请选择性别">
          <el-option label="男" value="男"></el-option>
          <el-option label="女" value="女"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <span class="require-flag">*</span>
          职务（头衔）
        </template>
        <el-input
          placeholder="请输入：推荐人职务"
          v-model="referrer.position"
        ></el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <span class="require-flag">*</span>
          联系电话
        </template>
        <el-input
          placeholder="请输入：推荐人电话"
          v-model="referrer.phone"
        ></el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <span class="require-flag">*</span>
          电子邮件（edu结尾）
        </template>
        <el-input
          placeholder="请输入：推荐人电子邮件"
          v-model="referrer.email"
        ></el-input>
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          <span class="require-flag">*</span>
          工作单位（具体到学院或单位部门）
        </template>
        <el-input
          placeholder="请输入：推荐人工作单位"
          v-model="referrer.corporate_name"
        ></el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <span class="require-flag">*</span>
          通讯地址（学校/单位地址）
        </template>
        <el-input
          placeholder="请输入：推荐人通讯地址"
          v-model="referrer.address"
        ></el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          推荐人官网链接
        </template>
        <el-input placeholder="请输入" v-model="referrer.con_12"></el-input>
      </el-descriptions-item>
    </el-descriptions>
    <div v-if="referrer.is_institution_write == 1">
      <p class="third-title-p">
        <span class="require-flag">*</span
        >1.根据你对推荐人的了解，在编写这封推荐信的时候，应该把握什么样的语言程度？下面有几个选项，请您认真选择（可多选），如有补充，请写在下面的空白处。
      </p>
      <el-descriptions direction="vertical" :column="1" border>
        <el-descriptions-item labelStyle="border:none;padding:0">
          <el-checkbox-group v-model="referrer.checkList">
            <el-checkbox label="成熟稳定，语言平实客观。"></el-checkbox><br />
            <el-checkbox
              label="语言显夸张，对你了解很深，能体现出积极推荐你的心情。"
            ></el-checkbox
            ><br />
            <el-checkbox
              label="推荐人对你没有太多的了解，但是很愿意推荐你。语言中性。"
            ></el-checkbox
            ><br />
            <el-checkbox label="语言无所谓,根据信息写就好。"></el-checkbox
            ><br />
            <el-checkbox label="其他补充要求："></el-checkbox><br />
          </el-checkbox-group>
          <el-input
            type="textarea"
            v-model="referrer.con_11"
            rows="6"
            v-if="checkCheckBoxAA()"
          ></el-input>
        </el-descriptions-item>
      </el-descriptions>

      <p class="third-title-p">
        <span class="require-flag">*</span>2.请简述当前推荐人和你之间的相关经历;
        <span style="color: red" @click="requirmentDialog = true"
          >点击查看要求></span
        >
      </p>
      <el-descriptions direction="vertical" :column="1" border>
        <el-descriptions-item labelStyle="border:none;padding:0">
          <el-input
            type="textarea"
            v-model="referrer.con_experience"
            rows="6"
            placeholder="填写前请点击查看要求"
          ></el-input>
        </el-descriptions-item>
      </el-descriptions>


      <p class="third-title-p">
        <span class="require-flag">*</span
        >3.请具体的谈谈推荐人的一些其它情况吧。比如推荐人是什么级别的，专家？教授？还是班主任。推荐人有没有海外背景，是不是交流学者等，因为这些信息有助于我们判断推荐信的语言。举个例子，一个学术大牛，推荐信的语言必然略显成熟而不会很夸张。这与推荐信的语言把握和可信度有很大关系。
        <span style="color: red">（可直接输入推荐人信息网址，输入网址头部需带上https:// 或 http://。输出网址后请输出一个空格和其他内容分开）</span>
      </p>
      <p v-for="item in this.urlList">
        <el-link :href="item" type="primary" target="_blank">{{item}}</el-link>
      </p>
      <el-descriptions direction="vertical" :column="1" border>
        <el-descriptions-item labelStyle="border:none;padding:0">
          <el-input
            type="textarea"
            v-model="referrer.con_10"
            rows="6"
            placeholder="请输入内容"
            @input="getUrlLink"
          ></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div v-if="referrer.is_institution_write == 2">
      <p class="third-title-p">
        <span class="require-flag">*</span
        >1.请具体的谈谈推荐人的一些其它情况吧。比如推荐人是什么级别的，专家？教授？还是班主任。推荐人有没有海外背景，是不是交流学者等，因为这些信息有助于我们判断推荐信的语言。举个例子，一个学术大牛，推荐信的语言必然略显成熟而不会很夸张。这与推荐信的语言把握和可信度有很大关系。
        <span style="color: red">（可直接输入推荐人信息网址，输入网址头部需带上https:// 或 http://。输出网址后请输出一个空格和其他内容分开）</span>
      </p>
      <p v-for="item in this.urlList">
        <el-link :href="item" type="primary" target="_blank">{{item}}</el-link>
      </p>
      <el-descriptions direction="vertical" :column="1" border>
        <el-descriptions-item labelStyle="border:none;padding:0">
          <el-input
            type="textarea"
            v-model="referrer.con_10"
            rows="6"
            placeholder="请输入内容"
            @input="getUrlLink"
          ></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <el-dialog
      title="填写要求"
      center
      :visible.sync="requirmentDialog"
      width="50%"
    >
      <p class="third-title-p">
        1.您和推荐人认识的时间，是通过什么事情认识的(时间，地点，途径)
      </p>
      <p class="third-title-p">2.如果推荐人是课程教师:</p>
      <p>
        a）教授课程的中英文名称，以及教授这门课程的时间。你的这门课程考试结果如何（如分数，排名等等）
      </p>
      <p>
        b）简述来往情况，如项目研究，有没有什么作业课题，或者课堂讨论、论文写作，活动策划等。合作中遇到哪些困难，怎样克服的？给老师曾经留下深刻的印象。如有，请列出具体的项目内容或讨论内容。
      </p>
      <p>
        c）推荐人对本人哪方面能力留下深刻印象并且非常认可？因何事件体现出来？请通过1-2个具体事例说明您如何给推荐人留下了深刻的印象，切忌空泛。
      </p>
      <p class="third-title-p">3.如果推荐人不是课程教师:</p>
      <p>
        a）该推荐人是否指导你进行过什么研究？详细介绍研究的项目(项目时间+研究项目名称+内容+你在研究项目中的职责与成绩)
      </p>
      <p>b）推荐人认为你还有哪些方面需要提高？</p>
      <p>
        c）以这位推荐人的角度来看，他是否了解你其他方面的能力，比如你的各科综合成绩如何,
        你的特长, 得过何种荣誉, 克服过某些困难，参加过什么样的校内外活动等。
        如果有的话，请用1-2个具体事例说明。
      </p>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "TabReferrer",
  components: {},
  props: {
    user_profile_checklist: {
      default: "",
    },
    user_profile_referrer: {
      default: "",
    },
  },
  watch: {
    user_profile_checklist: {
      handler(val, oldVal) {
        if (val) {
          this.checkList = val;
        }
      },
      immediate: true,
      deep: true,
    },
    user_profile_referrer: {
      handler(val, oldVal) {
        if (val) {
          this.referrer = val;
        }
      },
      immediate: true,
      deep: true,
    },
    referrer: {
      handler(val, oldVal) {
        if (val.con_10) {
          this.getUrlLink(val.con_10);
        }
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      requirmentDialog: false,
      checkList: [],
      referrer: {
        is_institution_write: "",
        checkList: [],
        surname: "",
        personal_name: "",
        email: "",
        contact_information: "",
        address: "",
        position: "",
        corporate_name: "",
        sex: "",
        con_1: "",
        con_2: "",
        con_3: "",
        con_4: "",
        con_5: "",
        con_6: "",
        con_7: "",
        con_8: "",
        con_9: "",
        con_10: "",
        con_11: "",
        con_12:"",
        relationship: "",
        recognize_time: "",
      },
      show: "",
      urlList: [],
    };
  },
  computed: {},
  methods: {
    getUrlLink(_str) {
      this.urlList = this.isURL(_str)
      console.log(this.urlList)
    },
    isURL(str) {
      str = str.replace(/[\u4e00-\u9fa5]/g, '')
      // 使用正则表达式匹配URL的模式
      let urlPattern = /(https?:\/\/[^\s]+)/g
      // 使用match方法提取匹配到的URL
      let urls = str.match(urlPattern)
      // 输出提取到的URL
      return urls
    },
    checkCheckBoxAA() {
      if (
        this.referrer.checkList &&
        this.referrer.checkList.indexOf("其他补充要求：") === -1
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.el-header {
  background-color: #fafafa;
  text-align: center;
  line-height: 60px;
}

.el-main {
  text-align: center;
  line-height: 160px;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
.require-flag {
  font-size: 20px !important;
  font-weight: 550 !important;
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_referrer.vue